import CANNABIS_TYPES from './cannabisTypes'

export default {
  [CANNABIS_TYPES.INDICA]: 'Indica',
  [CANNABIS_TYPES.SATIVA]: 'Sativa',
  [CANNABIS_TYPES.HYBRID]: 'Hybrid',
  [CANNABIS_TYPES.CBD]: 'CBD',
  [CANNABIS_TYPES.NA]: 'N/A',
}



// WEBPACK FOOTER //
// ./src/constants/cannabisTypeNames.js